"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
var _default2 = exports.default = {
  props: {
    title: String,
    // 网格显示标题
    billTag: String,
    scanTag: String,
    // 收货扫码标记
    sumItemQty: String,
    // 数量台账标记（不传排序）
    query: {
      // 查询输入控件清单
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cellClick: {
      // 单元格点击
      type: Function,
      default: function _default() {
        return [];
      }
    },
    resize: {
      // 是否启用自动调整grid大小
      type: Boolean,
      default: true
    },
    columns: {
      // 网格列清单
      type: Array,
      default: function _default() {
        return [];
      }
    },
    operations: {
      // 网格行按钮清单
      type: Array,
      default: function _default() {
        return [];
      }
    },
    operationsWidth: {
      // 操作栏宽度
      type: Number,
      default: 0
    },
    rowClickFireCheck: {
      // 点击数据行触发选中事件
      type: Boolean,
      default: true
    },
    tableCurrentChange: {
      // 列表选中项变化触发回调
      type: Function,
      default: null
    },
    buttons: {
      // 网格上方按钮清单
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dataUrl: String,
    // 数据请求url
    beforeBindData: {
      // 绑定数据前对数据处理
      type: Function,
      default: function _default(data) {
        return data;
      }
    },
    afterBindData: {
      // 绑定数据后回调函数
      type: Function
    },
    chooseItem: {
      // 网格是否可选择【'none', 'single',  'multiple'】
      type: String,
      default: 'none',
      validator: function validator(value) {
        return ['none', 'single', 'multiple' /*, 'multipleForManage'*/].indexOf(value) !== -1;
      }
    },
    pagination: {
      // 是否启用分页功能
      type: Boolean,
      default: true
    },
    gridIndex: {
      // 是否显示序号列
      type: Boolean,
      default: true
    },
    textProp: String,
    // 文本解析属性
    codeProp: {
      type: String,
      default: 'id'
    },
    // 选择值解析属性
    selectedCodes: {
      // 选中值
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initQuickQueryValue: String,
    // 快速搜索框提示信息
    cellStyle: {
      // 单元格样式
      type: Function,
      default: null
    },
    sortColumn: {
      // 默认排序列
      type: String,
      default: 'createTime'
    },
    sortOrder: {
      // 默认排序方式
      type: String,
      default: 'desc'
    },
    periodData: {
      // 期间数据
      type: String,
      default: ''
    },
    rowspanArray: {
      // 合并行/列表格
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dbClickBtn: {
      type: Boolean,
      default: false
    },
    /* 设置 Request */
    setRequest: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};